module.exports = __webpack_public_path__ + "img/csl-behring-logo.73cdc33b.svg";